__turbopack_context__.v({
  "palette": "Nj4UHW_palette",
});
